// 颜色常量
export const COLORS = {
  longFlow: '#FF9247',
  longFlowLight: '#F58F65',
  nonLongFlow: '#00ADFF',
  nonLongFlowLight: '#32B2EE',
  trendLine: '#FFCB47',
  trendLineLight: '#FFD34F',
  pressure: '#16DD8E',
  pressureLight: '#49CC98',
  longFlowBg: 'rgba(255,146,71,0.1)',
  nonLongFlowBg: 'rgba(0,173,255,0.1)',
} as const;

// 其他常量
export const MAX_RANK_COUNT = 100;
export const MAX_DATE_SPAN_DAYS = 31;
